import { useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'
import { GET_MIGRANTS_REPORTS } from '../../../../graphql/Catalog/Migrants/migrantsProcess'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import LayoutTable from '../../../Global/LayoutTable'
import moment from 'moment'
import MigrantsProcessHistoryDetails from './MigrantsProcessHistoryDetails'

const MigrantsProcessHistory = ({ user, id }) => {
  // -------------- Hooks --------------
  const [pagePagination, setPagePagination] = useState({
    limit: 10,
    offset: 0,
  })
  const [dataTable, setDataTable] = useState({
    rows: [],
    count: 0,
  })
  const [reportsView, setReportsView] = useState({
    show: id ? true : false,
    id: id || null,
  })
  // -------------- Queries and Mutations --------------
  const { data, loading, error, refetch } = useQuery(GET_MIGRANTS_REPORTS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      user_id: user?.idUser, // You can set a specific user ID if needed
    },
    fetchPolicy: 'cache-and-network',
  })
  // -------------- UseEffect --------------
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data?.getMigrantsReports?.rows.map((item) => {
        return list.push({
          id: item.id,
          Fecha: item?.date
            ? moment(item?.date).format('D [de] MMMM[,] YYYY[-] h:mm a')
            : 'Sin datos',
          Trámite: item?.process,
          Estatus: <ProgressBarStatusReport statusReport={item?.status} />,
          accions_custom: (
            <div className="my-3 d-flex flex-column acciones">
              <div className="d-flex" style={{ gap: '5px' }}>
                <span
                  onClick={() => {
                    setReportsView({
                      show: true,
                      id: item.id,
                    })
                  }}
                >
                  <i className="fas fa-eye mr-3" />
                </span>
              </div>
            </div>
          ),
        })
      })
      setDataTable({
        rows: list,
        count: data?.getMigrantsReports?.count,
      })
    }
  }, [data, loading, error])

  return (
    <div className="migrants-process-history">
      {reportsView.show ? (
        <MigrantsProcessHistoryDetails
          reportId={parseInt(reportsView?.id || 0)}
          user={user}
        />
      ) : (
        <LayoutTable
          hideId
          title=""
          data={dataTable.rows}
          totalCount={dataTable.count}
          pagePagination={pagePagination}
          setPagePagination={setPagePagination}
          loadingData={loading}
          requery={GET_MIGRANTS_REPORTS}
          refetchFunctionQueries={refetch}
          exportImportButton={false}
          hideFilterBar
          hideActions
        />
      )}
    </div>
  )
}

export default MigrantsProcessHistory
